<template>
  <div class="all-main">
    <div class="all-title">客户选择</div>
    <div class="all-search">
      <div class="search-border">
        <span>
          <img :src="imgSearch" alt />
        </span>
        <span>
          <input type="text" v-model="searchValue" placeholder="请输入客户姓名,证件号码" />
        </span>
        <span class="search-button" @click="searchCustomer">搜索</span>
      </div>
    </div>
    <div class="body" v-for="(item, index) in customer" :key="index">
      <div class="all-body" @click="choiceCutomer(index)">
        <span class="body-portrait">{{item.customerName.substring(0,1)}}</span>
        <div class="body-up">
          <span>{{item.customerName}}</span>
          <span>{{item.gender}}</span>
          <span></span>
        </div>
        <div class="body-down">
          <span>{{item.identifyTypeName}}</span>
          <span>{{item.idNumber}}</span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="bottom-choice"> 
      <span class="prev-text" @click="getCustomerList('',pageNo-1)">上一页</span>
      <span>{{pageNo}}/{{pages}}</span>
      <span class="bext-text" @click="getCustomerList('',pageNo+1)">下一页</span>
    </div>
    <Loading :switchs="switchs"></Loading>
  </div>
</template>
<script>
import api from "@/api/api.js"
import Loading from '@/components/Loadings/Loading'
import { Toast } from 'vant'
export default {
  name: "Customer",
  data() {
    return {
      imgSearch: api.imgAllUrl + "/search0710.png",
      searchValue: "", // 查询条件
      switchs: false, // loading
      customer: [],
      pageNo:1,// 当前页数，
      pages:10,//总页数
    }
  },
  components: {
    "Loading": Loading,
  },
  props: {
    isContact: {
      type: Boolean
    },
    condition: {
      type: String
    }
  },
  mounted() {
    this.getCustomerList("",1)
  },
  methods: {
    /**
     * 选择客户
     */
    choiceCutomer(num) {
      this.switchs = true
      this.$http
        .get(api.getCustomerById + '/' + this.customer[num].customerId)
        .then(res => {
          this.switchs = false
          if (res.data.rtnCode === "0000") {
             this.$emit("cuntomer", res.data)
             this.$emit("isContact", this.isContact)
          } else {
            Toast(res.data.rtnMsg)
          }
        })
        .catch(error => {
          this.switchs = false
          console.log(error)
        })
        
    },
    /**
     * 客户查询
     */
    searchCustomer() {
      this.getCustomerList(this.searchValue,1)
    },
    getCustomerList(condition,pageNo) {
      if(pageNo < 1 ) {
        Toast('当前为第一页')
        return
      } else if( pageNo > this.pages) {
        Toast('当前为最后一页')
        return
      }
      this.pageNo = pageNo
      
      var param = {
        condition: condition,
        pageNo: pageNo,
        pageSize: 10,
        queryType: 0
      }
      this.switchs = true
      this.$http
        .post(api.getCustomerList, param)
        .then(res => {
          this.switchs = false
          if (res.data.rtnCode === "0000") {
            this.customer = res.data.customerPageInfo.content
            for(var i = 0; i < this.customer.length;i++){
              switch(this.customer[i].gender) {
                case '0': this.customer[i].gender = '';break
                case '1': this.customer[i].gender  = '男';break
                case '2': this.customer[i].gender  = '女';break
              }
            }
            this.pages = res.data.customerPageInfo.pages
           } else {
            Toast(res.data.rtnMsg)
          }
        })
        .catch(error => {
          this.switchs = false
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./index.scss"
</style>


// WEBPACK FOOTER //
// src/components/Customer/index.vue